"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AUTH_SESSION_RESUME = exports.AUTH_SESSION_PAUSE = exports.AUTH_SESSION_END = exports.AUTH_SESSION_START = exports.ACCESS_TOKEN_UNAVAILABLE = exports.ACCESS_TOKEN_AVAILABLE = exports.FETCH_AUTH_USER_FAILURE = exports.FETCH_AUTH_USER_SUCCESS = exports.FETCH_AUTH_USER_REQUEST = exports.PROCESS_TOKEN_REFRESH = exports.AUTH_REFRESH_TOKEN_FAILURE = exports.AUTH_REFRESH_TOKEN_SUCCESS = exports.AUTH_REFRESH_TOKEN = exports.SET_AUTH_TOKENS = exports.AUTH_LOGOUT = exports.AUTH_LOGIN_FAILURE = exports.AUTH_LOGIN_SUCCESS = exports.AUTH_LOGIN = void 0;
var AUTH_LOGIN = '@@redux-token-auth/AUTH_LOGIN';
exports.AUTH_LOGIN = AUTH_LOGIN;
var AUTH_LOGIN_SUCCESS = '@@redux-token-auth/AUTH_LOGIN_SUCCESS';
exports.AUTH_LOGIN_SUCCESS = AUTH_LOGIN_SUCCESS;
var AUTH_LOGIN_FAILURE = '@@redux-token-auth/AUTH_LOGIN_FAILURE';
exports.AUTH_LOGIN_FAILURE = AUTH_LOGIN_FAILURE;
var AUTH_LOGOUT = '@@redux-token-auth/AUTH_LOGOUT';
exports.AUTH_LOGOUT = AUTH_LOGOUT;
var SET_AUTH_TOKENS = '@@redux-token-auth/SET_AUTH_TOKENS';
exports.SET_AUTH_TOKENS = SET_AUTH_TOKENS;
var AUTH_REFRESH_TOKEN = '@@redux-token-auth/AUTH_REFRESH_TOKEN';
exports.AUTH_REFRESH_TOKEN = AUTH_REFRESH_TOKEN;
var AUTH_REFRESH_TOKEN_SUCCESS = '@@redux-token-auth/AUTH_REFRESH_TOKEN_SUCCESS';
exports.AUTH_REFRESH_TOKEN_SUCCESS = AUTH_REFRESH_TOKEN_SUCCESS;
var AUTH_REFRESH_TOKEN_FAILURE = '@@redux-token-auth/AUTH_REFRESH_TOKEN_FAILURE';
exports.AUTH_REFRESH_TOKEN_FAILURE = AUTH_REFRESH_TOKEN_FAILURE;
var PROCESS_TOKEN_REFRESH = '@@redux-token-auth/PROCESS_TOKEN_REFRESH';
exports.PROCESS_TOKEN_REFRESH = PROCESS_TOKEN_REFRESH;
var FETCH_AUTH_USER_REQUEST = '@@redux-token-auth/FETCH_AUTH_USER_REQUEST';
exports.FETCH_AUTH_USER_REQUEST = FETCH_AUTH_USER_REQUEST;
var FETCH_AUTH_USER_SUCCESS = '@@redux-token-auth/FETCH_AUTH_USER_SUCCESS';
exports.FETCH_AUTH_USER_SUCCESS = FETCH_AUTH_USER_SUCCESS;
var FETCH_AUTH_USER_FAILURE = '@@redux-token-auth/FETCH_AUTH_USER_FAILURE';
exports.FETCH_AUTH_USER_FAILURE = FETCH_AUTH_USER_FAILURE;
var ACCESS_TOKEN_AVAILABLE = '@@redux-token-auth/ACCESS_TOKEN_AVAILABLE';
exports.ACCESS_TOKEN_AVAILABLE = ACCESS_TOKEN_AVAILABLE;
var ACCESS_TOKEN_UNAVAILABLE = '@@redux-token-auth/ACCESS_TOKEN_UNAVAILABLE';
exports.ACCESS_TOKEN_UNAVAILABLE = ACCESS_TOKEN_UNAVAILABLE;
var AUTH_SESSION_START = '@@redux-token-auth/AUTH_SESSION_START';
exports.AUTH_SESSION_START = AUTH_SESSION_START;
var AUTH_SESSION_END = '@@redux-token-auth/AUTH_SESSION_END';
exports.AUTH_SESSION_END = AUTH_SESSION_END;
var AUTH_SESSION_PAUSE = '@@redux-token-auth/AUTH_SESSION_PAUSE';
exports.AUTH_SESSION_PAUSE = AUTH_SESSION_PAUSE;
var AUTH_SESSION_RESUME = '@@redux-token-auth/AUTH_SESSION_RESUME';
exports.AUTH_SESSION_RESUME = AUTH_SESSION_RESUME;